import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { CategoryData, getExportingOptions } from '../utils/jsonDataProcessing';

interface CategoryBarChartProps {
  categoryData: CategoryData;
}

const CategoryBarChart: React.FC<CategoryBarChartProps> = ({ categoryData }) => {
  const options = {
    chart: {
      type: 'column',
      height: '400px'
    },
    title: {
      text: ''
    },
    xAxis: {
      categories: Object.keys(categoryData.categoryCounts)
      .filter(category => categoryData.categoryCounts[category] > 0),
      crosshair: true
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Number of Keywords'
      }
    },
    tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y}</b></td></tr>',
      footerFormat: '</table>',
      shared: true,
      useHTML: true
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
    series: [{
      name: 'Keywords',
      data: Object.values(categoryData.categoryCounts).
      filter(count => count > 0),
    }],
    ...getExportingOptions('Category Counts Bar')
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default CategoryBarChart;
